import React from "react";
import Left_menu from "./Left_menu";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ProgressBar,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
// import './customer_style.css';
import Modal from "react-bootstrap/Modal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import ReactLoading from "react-loading";
import config from "../../config";
import Moment from "react-moment";
import download from "downloadjs";
import TablePagination from "@mui/material/TablePagination";
import { useNetworkState } from "react-use";
import {
  Ban,
  Copy,
  CornerUpLeft,
  FileEdit,
  Package,
  PackageOpen,
  Plus,
  RefreshCcw,
  ShoppingBag,
  ShoppingBasket,
  Trash,
  Truck,
  Upload,
} from "lucide-react";
import Footer from "../Footer";
import moment from "moment";
const Customer_orders = () => {
  let navigate = useNavigate();
  const isOnline = useNetworkState();
  console.log("isONline  === ", isOnline);
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  const [packagestate, setpackageState] = React.useState([]);
  const [userstate, setUserState] = React.useState({});
  // const[loadingstate,setLoadingstate] = React.useState({loading:false})
  const [errorstate, seterrorstate] = React.useState({ message: "" });
  const [recordid, setRecordid] = React.useState({ record_id: "" });
  const [uploadModalState, setUploadModalState] = React.useState({
    show: false,
    excel_fle: "",
  });
  const [dimensionState, setdimensionState] = React.useState({
    companyDetail: [],
  });
  const [state, setState] = React.useState({
    shipment_list: [],
    isLoading: true,
  });
  const [shipmentstate, setshipStatus] = React.useState({
    shipment_status: null,
  });
  const [shipSelect, setShipSelect] = React.useState({
    shipment_id: "",
    cancel_reason: "",
  });
  const [modalState, setModalState] = React.useState({ show: false });

  const [loadingstate, setLoadingstate] = React.useState(false);
  const [summarystate, setSummarystate] = React.useState(false);
  const [isLoading, setisLoading] = React.useState(true);
  const [syncLoading, setsyncLoading] = React.useState(false);
  const [selected, setSelected] = React.useState({
    select_count: 0,
    select_order_id: [],
  });
  const [searchstate, setsearchstate] = React.useState({ search_shipment: "" });

  const [productselect, setProductselect] = React.useState({
    product_id: "",
    carrier_id: "",
  });
  const [otherStates, setOtherState] = React.useState({
    dstatus: "",
    activePage: 1,
    rowsPerPage: 20,
    page: 0,
    total_count: 0,
    onload: true,
  });
  // console.log("otherState ==== " , otherStates)
  // console.log("selected === " , selected)
  const [product, setproduct] = React.useState([]);
  const [onSubmitButton, setonSubmit] = React.useState(false);

  const [openOffcanvas, setOpenOffcanvas] = React.useState(false);
  const [openOffdetailcanvas, setOpenOffdetailcanvas] = React.useState(false);

  const [warehosuestate, setWarehouseState] = React.useState({ warehouse: "" });
  const [packageloading, setpackageloading] = React.useState({
    loading: false,
  });
  const [bookorder, setbookorder] = React.useState([]);
  const [alloctedata, setallocatedata] = React.useState([]);
  console.log("bookorder", bookorder);
  const [otherState, setOtherStates] = React.useState({ submit_button: false });
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [date, setdate] = React.useState({
    from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
  });

  const [paymentmode, setpaymentmode] = React.useState({
    cod: false,
    prepaid: false,
  });
  const [warehouse, setwarehouse] = React.useState([]);
  const [selectedWarehouses, setSelectedWarehouses] = React.useState([]);
  const [sortOption, setSortOption] = React.useState("Recommended");
  const [sub, setSub] = React.useState(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 5000,
  });

  React.useEffect(() => {
    shipment_list(null, 0, true);
  }, [paymentmode, selectedWarehouses]);

  // console.log("shipmentState",shipmentstate)
  React.useEffect(() => {
    shipment_list(null, 0, true);
    dimension_detail();
    get_warehouse();
    user();
  }, [otherStates.rowsPerPage]);
  const user = () => {
    let dataToSend = {};

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/find_customer_detail";
    //  console.log("headers =========> ", config.headers);
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("res ===" , res.data.output)
        setUserState(res.data.output);
        let response = res.data.ouptut;
        // console.log("response ===" , response)
        //   const obscuredAadhar = obscureAadharNumber(res.data.ouptut.aadhaar_number);
        // console.log("obscuredAadhar == " , obscuredAadhar)
        // setAadharNumber(obscuredAadhar);
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  const shipment_list = (status, index = 0, onLoad) => {
    let dataToSend = {
      customer_id: userData.customer_id,
      find: searchstate.search_shipment,
      status: status,
      limit: otherStates.rowsPerPage,
      indexValue: index,
      mode: "Domestic",
    };
    if (date.from_date != "" && date.to_date != "") {
      dataToSend.from_date = date.from_date;
      dataToSend.to_date = date.to_date;
    }
    if (selectedWarehouses.length > 0) {
      dataToSend.warehouse = selectedWarehouses;
    }
    if (paymentmode.cod && !paymentmode.prepaid) {
      dataToSend.payment_mode = "cod";
    } else if (!paymentmode.cod && paymentmode.prepaid) {
      dataToSend.payment_mode = "prepaid";
    } else if (paymentmode.cod && paymentmode.prepaid) {
      dataToSend.payment_mode = "both";
    }

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/shipment/customer_orders";

    // console.log("headers => ", config.headers);

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (onLoad) {
          setOtherState({
            ...otherStates,
            total_count: res.data.count,
            page: index,
          });
        }
        setState({ shipment_list: res.data.output, isLoading: false });
        setisLoading(false);
      })
      .catch((error) => {
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        // console.log(error);
      });
  };
  const handlePageChange = (event, newPage) => {
    setOtherState({ ...otherStates, page: newPage });
    // console.log("newPage ", newPage);
    // getCountryList(newPage);
    shipment_list(shipmentstate.shipment_status, newPage, true);
  };
  const handleChangeRowsPerPage = (event, newPage) => {
    // console.log("event ", event.target.value);
    setOtherState({ ...otherStates, rowsPerPage: event.target.value });
  };

  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setdimensionState({
          ...dimensionState,
          companyDetail: res.data.companyDetail,
        });
        // console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };

  const get_warehouse = () => {
    let full_api = config.apiUrl + `/shipment/getAllWarehouse`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        if (res.data.status == true) {
          setwarehouse(res.data.output);
        }
        console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //  toast.error("Some thing went wrong")
        console.log("----error:   ", e);
      });
  };

  const syncOrders = () => {
    setsyncLoading(true);
    let full_api = config.apiUrl + `/shipment/sync_orders`;
    let sendData = { customer_id: userData.customer_id };

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        // console.log("rnmmmmm", res);
        if (res.data.status == true) {
          setsyncLoading(false);
          shipment_list();
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#10b93b",
            type: "error",
            title: "Something Went Wrong!",
            color: "white",
          });
        }
      })
      .catch((e) => {
        // console.log("----error:   ", e);
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#10b93b",
          type: "error",
          title: "Something Went Wrong!",
          color: "white",
        });
      });
  };

  const clone_order = (sub) => {
    // console.log("order_id")

    let dataToSend = {
      sender_name: sub.sender[0].name,
      sender_mobile: sub.sender[0].mobile,
      sender_email: sub.sender[0].email,
      sender_address: sub.sender[0].address,
      sender_city: sub.sender[0].city,
      sender_city_id: sub.sender[0].city_id,
      sender_state_name: sub.sender[0].state,
      sender_country_name: sub.sender[0].country,
      sender_country_code: sub.sender[0].country_code,
      sender_postal_code: sub.sender[0].pincode,
      receiver_name: sub.receiver[0].name,
      receiver_mobile: sub.receiver[0].mobile,
      receiver_email: sub.receiver[0].email,
      receiver_address: sub.receiver[0].address,
      receiver_city: sub.receiver[0].city,
      receiver_country_name: sub.receiver[0].country,
      receiver_country_code: sub.receiver[0].country_code,
      receiver_postal_code: sub.receiver[0].pincode,
      receiver_state_name: sub.receiver[0].state,
      receiver_state_id: sub.receiver[0].state_id,
      receiver_city_id: sub.receiver[0].city_id,
      return_name: sub.return[0].name,
      return_mobile: sub.return[0].mobile,
      return_email: sub.return[0].email,
      return_address: sub.return[0].address,
      return_city: sub.return[0].city,
      return_state_name: sub.return[0].state,
      return_country_name: sub.return[0].country,
      return_country_code: sub.return[0].country_code,
      return_postal_code: sub.return[0].pincode,
      payment_mode: sub.payment_mode,
      shipment_type: sub.type,
      cod_amount: sub.cod_amount,
      volumetric_weight: sub.volumetric_weight,
      total_weight: sub.total_weight,
      dead_weight: sub.dead_weight,
      length: sub.length,
      height: sub.height,
      width: sub.width,
      insurance_amount: sub.insurance_amount,
      type: sub.type,
      address_id: sub.address_id,
      order_id: "",
      order_date: "",
      mode: sub.mode,
      carrier_type: 1,
      order_type: sub.order_type ? (sub.order_type == "Fulfilled" ? 2 : 1) : 1,
      items: sub.items,
    };

    dataToSend.item_name = sub.items.map((i) => i.item_name);
    dataToSend.item_value = sub.items.map((i) => i.item_value);
    dataToSend.quantity = sub.items.map((i) => i.item_quantity);

    dataToSend.customer_id = userData.customer_id;
    // console.log("datatoSend", dataToSend)

    let url = config.apiUrl + "/shipment/order_create";

    // setOtherState({ ...otherState, submit_button: false })
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((responseJson) => {
        // console.log("responseJson => ", responseJson.data.output);
        // setOtherState({ ...otherState, submit_button: true })
        if (responseJson.data.status == true) {
          shipment_list();
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Order created successfully.",
            color: "white",
          });
          setOpenOffdetailcanvas(false);
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Something Went Wrong.",
            color: "white",
          });
        }
      });
  };
  //   const next_step = (sub)=>{

  //     if(sub.sender[0].name!=undefined && sub.sender[0].name!="" && sub.sender[0].address!=undefined && sub.sender[0].address!="" &&sub.sender[0].country!=undefined && sub.sender[0].country!="" && sub.sender[0].country_code!=undefined && sub.sender[0].country_code!="" && sub.sender[0].pincode!=undefined && sub.sender[0].pincode!="" && sub.sender[0].state!=undefined && sub.sender[0].state!="" && sub.sender[0].city!=undefined && sub.sender[0].city!="" && sub.address_id!=undefined && sub.address_id!="" && sub.sender[0].city_id!=undefined && sub.sender[0].city_id!="" && sub.sender[0].mobile!=undefined && sub.sender[0].mobile!="" && sub.sender[0].email!=undefined && sub.sender[0].email!="" && sub.receiver[0].name!=undefined && sub.receiver[0].name!="" && sub.receiver[0].email!=undefined && sub.receiver[0].email!="" && sub.receiver[0].mobile!=undefined && sub.receiver[0].mobile !="" && sub.receiver[0].address !=undefined && sub.receiver[0].address!="" && sub.receiver[0].country!=undefined && sub.receiver[0].country!="" && sub.receiver[0].country_code!=undefined && sub.receiver[0].country_code!="" && sub.receiver[0].pincode!=undefined && sub.receiver[0].pincode!="" && sub.receiver[0].city!=undefined && sub.receiver[0].city!="" && sub.receiver[0].state!=undefined && sub.receiver[0].state!="" && sub.return[0].name!=undefined && sub.return[0].name!="" && sub.return[0].email!=undefined && sub.return[0].email!="" && sub.return[0].mobile!=undefined && sub.return[0].mobile !="" && sub.return[0].address !=undefined && sub.return[0].address!="" && sub.return[0].country!=undefined && sub.return[0].country!="" && sub.return[0].country_code!=undefined && sub.return[0].country_code!="" && sub.return[0].pincode!=undefined && sub.return[0].pincode!="" && sub.return[0].city!=undefined && sub.return[0].city!="" && sub.return[0].state!=undefined && sub.return[0].state!=""  && sub.mode!=undefined && sub.mode !="" && sub.items.length >0 && sub.type!=undefined && sub.type!="" && sub.order_number!=undefined && sub.order_number!=""  && sub.total_weight!=undefined && sub.total_weight!="" && sub.height!=undefined && sub.height!="" && sub.width!=undefined && sub.width!="" && sub.length!=undefined && sub.length!="" && sub.cod_amount !=undefined  &&  sub.payment_mode!=undefined && sub.payment_mode!="" && sub.volumetric_weight!=undefined  ){
  //       if (sub.payment_mode == "cod" && sub.cod_amount!=undefined && sub.cod_amount <= 0) {
  //         const Toast = Swal.mixin({
  //           toast: true,
  //           position: 'bottom-end',
  //           showConfirmButton: false,
  //           timer: 3000
  //         });
  //         Toast.fire({
  //           background: "rgb(25, 135, 84)",
  //           type: 'unsuccess',
  //           title: "COD amount must be greater than 0.",
  //           color: "white"
  //         });
  //       }
  //       else{
  //         navigate({pathname:`/customer/package_list`,
  //         search: `sender_name=${sub.sender[0].name}&sender_address=${sub.sender[0].address}&sender_country=${sub.sender[0].country}&sender_country_code=${sub.sender[0].country_code}&sender_postal_code=${sub.sender[0].pincode}&sender_state_name=${sub.sender[0].state}&sender_city=${sub.sender[0].city}&sender_address_id=${sub.address_id}&sender_city_id=${sub.sender[0].city_id}&sender_mobile=${sub.sender[0].mobile}&sender_email=${sub.sender[0].email}&receiver_name=${sub.receiver[0].name}&receiver_email=${sub.receiver[0].email}&receiver_mobile=${sub.receiver[0].mobile}&receiver_address=${sub.receiver[0].address}&receiver_country=${sub.receiver[0].country}&receiver_country_code=${sub.receiver[0].country_code}&receiver_postal_code=${sub.receiver[0].pincode}&receiver_city=${sub.receiver[0].city}&receiver_state_name=${sub.receiver[0].state}&return_name=${sub.return[0].name}&return_email=${sub.return[0].email}&return_mobile=${sub.return[0].mobile}&return_address=${sub.return[0].address}&return_country=${sub.return[0].country}&return_country_code=${sub.return[0].country_code}&return_postal_code=${sub.return[0].pincode}&return_city=${sub.return[0].city}&return_state_name=${sub.return[0].state}&mode=${sub.mode}${sub.items.map((i)=>(`&items=${i.item_value},${i.item_name},${i.item_quantity}`))}&shipment_type=${sub.type}&insurance=${sub.insurance_amount}&order_id=${sub.order_number}&order_date=${sub.order_date}&weight=${sub.total_weight}&height=${sub.height}&width=${sub.width}&length=${sub.length}&cod_amount=${sub.cod_amount}&payment_mode=${sub.payment_mode}&store_id=${sub.store_id!=undefined?sub.store_id:""}&channel_name=${sub.channel_name!=undefined?sub.channel_name:""}&volumetric_weight=${sub.volumetric_weight}&receiver_city_id=${sub.receiver[0].city_id}&receiver_state_id=${sub.receiver[0].state_id}&channel_id=${sub.channel_id?sub.channel_id:""}`
  //       })
  //       }

  // }
  // else{
  //   const Toast = Swal.mixin({
  //     toast: true,
  //     position: 'bottom-end',
  //     showConfirmButton: false,
  //     timer: 3000
  //   })
  // Toast.fire({
  // background:"rgb(25, 135, 84)",
  // type: 'unsuccess',
  // title: "Please Fill All The Details.",
  // color:"white"
  // });
  // }

  //   }
  const convertToYYYYMMDD = (inputDate) => {
    const dateParts = inputDate.split(/[-/]/); // Split by / or -
    // return `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const sanitize = (val) => {
    if (!val) return "";
    return encodeURIComponent(
      val.toString().replace(/[^\w\s.@-]/gi, "") // remove special characters except . @ -
    );
  };

  const sanitizeItemName = (str = "") => {
    return str
      .replace(/[\r\n]/g, " ") // remove line breaks
      .replace(/&/g, "and") // VERY IMPORTANT
      .replace(/[()]/g, "")
      .replace(/-/g, " ")
      .replace(/[^\w\s]/gi, "") // remove all special chars
      .replace(/\s+/g, " ")
      .trim();
  };
  const removeHash = (text) => {
    return text ? text.replace(/#/g, "") : "";
  };

  const edit_order = (sub) => {
    const sanitizedItems = sub.items.map((item) => ({
      ...item,
      item_name: sanitizeItemName(item.item_name),
      item_description: sanitizeItemName(item.item_description),
      item_sku: sanitizeItemName(item.item_sku),
    }));
    const itemsJson = JSON.stringify(sanitizedItems);
    const encodedItems = encodeURIComponent(itemsJson);
    const orderDate = sub.order_date;
    const formattedOrderDate = convertToYYYYMMDD(orderDate);

    navigate({
      pathname: `/customer/create_order_1`,
      search:
        `value=${sub.mode == "Domestic" ? 0 : 1}` +
        `&receiver_name=${sanitize(sub.receiver[0].name)}` +
        `&receiver_email=${sub.receiver[0].email}` +
        `&receiver_mobile=${sub.receiver[0].mobile}` +
        `&receiver_address=${encodeURIComponent(
          removeHash(sub.receiver[0].address)
        )}` +
        `&receiver_country=${sub.receiver[0].country}` +
        `&receiver_country_code=${sub.receiver[0].country_code}` +
        `&receiver_postal_code=${sub.receiver[0].pincode}` +
        `&receiver_city=${sub.receiver[0].city}` +
        `&receiver_state_name=${sub.receiver[0].state}` +
        `&sender_name=${sanitize(sub.sender[0].name)}` +
        `&sender_address=${encodeURIComponent(
          removeHash(sub.sender[0].address)
        )}` +
        `&sender_country=${sub.sender[0].country}` +
        `&sender_country_code=${sub.sender[0].country_code}` +
        `&sender_postal_code=${sub.sender[0].pincode}` +
        `&sender_state_name=${sub.sender[0].state}` +
        `&sender_city=${sub.sender[0].city}` +
        `&sender_address_id=${sub.address_id}` +
        `&sender_city_id=${sub.sender[0].city_id}` +
        `&sender_mobile=${sub.sender[0].mobile}` +
        `&sender_email=${sub.sender[0].email}` +
        `&return_name=${sanitize(sub.return[0].name)}` +
        `&return_email=${sub.return[0].email}` +
        `&return_mobile=${sub.return[0].mobile}` +
        `&return_address=${encodeURIComponent(
          removeHash(sub.return[0].address)
        )}` +
        `&return_country=${sub.return[0].country}` +
        `&return_country_code=${sub.return[0].country_code}` +
        `&return_postal_code=${sub.return[0].pincode}` +
        `&return_city=${sub.return[0].city}` +
        `&return_state_name=${sub.return[0].state}` +
        `&mode=${sub.mode}` +
        `&items=${encodedItems}` +
        `&shipment_type=${sub.type}` +
        `&insurance=${sub.insurance_amount}` +
        `&order_id=${sub.order_number}` +
        `&order_date=${formattedOrderDate}` +
        `&weight=${sub.total_weight}` +
        `&height=${sub.height}` +
        `&width=${sub.width}` +
        `&length=${sub.length}` +
        `&cod_amount=${sub.cod_amount}` +
        `&payment_mode=${sub.payment_mode}` +
        `&store_id=${sub.store_id ? sub.store_id : ""}` +
        `&channel_name=${sub.channel_name ? sub.channel_name : ""}` +
        `&volumetric_weight=${sub.volumetric_weight}` +
        `&dead_weight=${sub.dead_weight}` +
        `&receiver_state_id=${sub.receiver[0].state_id}` +
        `&receiver_city_id=${sub.receiver[0].city_id}`,
    });
  };

  const handleChangeSelected = (e, sub) => {
    setSelected((prevSelected) => {
      if (prevSelected.select_order_id.includes(sub.order_number)) {
        // Remove the orderId if it's already in the selected list
        return {
          select_count: prevSelected.select_count - 1,
          select_order_id: prevSelected.select_order_id.filter(
            (id) => id !== sub.order_number
          ),
        };
      } else {
        // Add the orderId if it's not in the selected list
        return {
          select_count: prevSelected.select_count + 1,
          select_order_id: [...prevSelected.select_order_id, sub.order_number],
        };
      }
    });
  };

  const product_list = () => {
    let dataToSend = {};
    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/shipment/all_product_list";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        setproduct(res.data.output);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const showModal = () => {
    if (userstate.allocate == 0) {
      product_list();
      setModalState({ show: true });
    } else {
      onsubmitbulk();
    }
  };

  const onChangeProduct = (e) => {
    // console.log("e == " , e)
    let values = Object.assign({}, e.target.value.split(","));
    // console.log("first",values[0])
    let product_id = values[0];
    let carrier_id = values[1];
    setProductselect({
      ...productselect,
      product_id: product_id,
      carrier_id: carrier_id,
    });
  };

  const onsubmit = () => {
    setonSubmit(true);
    let dataToSend = {
      order_id: selected.select_order_id,
      product_id: productselect.product_id,
      carrier_id: productselect.carrier_id,
    };
    // console.log("datatoSend",dataToSend)
    if (productselect.product_id != "" && productselect.carrier_id != "") {
      let url = config.apiUrl + "/shipment/bulk_shipment_booking";
      axios
        .post(url, dataToSend, { headers: config.headers })
        .then((res) => {
          //  console.log("responseJson => ", res);
          if (res.data.status == true) {
            setonSubmit(false);
            navigate(`/customer/bulk_orders_log/${res.data.log_id}`);
          } else {
            setonSubmit(false);
          }
          //  setproduct(res.data.output)
        })
        .catch((error) => {
          //  console.log(error);
          setonSubmit(false);
        });
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "rgb(25, 135, 84)",
        type: "unsuccess",
        title: "Please Select Product Type.",
        color: "white",
      });
    }
  };

  const onsubmitbulk = () => {
    setonSubmit(true);
    let dataToSend = {
      order_id: selected.select_order_id,
    };
    let url = config.apiUrl + "/shipment/allocate_bulk_shipment_booking";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        //  console.log("responseJson => ", res);
        if (res.data.status == true) {
          setonSubmit(false);
          navigate(`/customer/bulk_orders_log/${res.data.log_id}`);
        } else {
          setonSubmit(false);
        }
        //  setproduct(res.data.output)
      })
      .catch((error) => {
        //  console.log(error);
        setonSubmit(false);
      });
  };

  const modalClose = () => {
    setModalState({ show: false });
    setProductselect({ ...productselect, product_id: "", carrier_id: "" });
  };

  const handleSelectAll = (event) => {
    const selectedIds = event.target.checked
      ? state.shipment_list.map((order) => order.order_number)
      : [];

    setSelected({
      select_count: selectedIds.length,
      select_order_id: selectedIds,
    });
  };

  const cancelOrder = (sub) => {
    let dataToSend = {
      order_id: sub.order_number,
    };
    // console.log("datatoSend",dataToSend)

    let url = config.apiUrl + "/shipment/cancel_order";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        //  console.log("responseJson => ", res);
        if (res.data.status == true) {
          shipment_list(null, 0, true);
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Order Cancelled",
            color: "white",
          });
          setOpenOffdetailcanvas(false);
        }
        //  setproduct(res.data.output)
      })
      .catch((error) => {
        //  console.log(error);
      });
  };
  const cancelBulkOrder = () => {
    let dataToSend = {
      order_id: selected.select_order_id,
    };
    // console.log("datatoSend",dataToSend)

    let url = config.apiUrl + "/shipment/cancel_bulk_order";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        //  console.log("responseJson => ", res);
        if (res.data.status == true) {
          shipment_list(null, 0, true);
          // window.location.reload()
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Orders Cancelled",
            color: "white",
          });
          window.location.reload();
        }
        //  setproduct(res.data.output)
      })
      .catch((error) => {
        //  console.log(error);
      });
  };

  const handlesearchShipment = (e) => {
    setsearchstate({ search_shipment: e.target.value });
  };
  const get_list = async (sortValue, sorting) => {
    console.log("sortValue == ", sortValue);

    setpackageloading({ ...packageloading, loading: true });

    let sort = "default";
    if (sortValue) {
      sort = sortValue;
    }
    setWarehouseState({
      warehouse: sortValue.warehouse_id
        ? sortValue.warehouse_id
        : sortValue.warehouse_name,
    });
    let dataToSend = {
      customer_id: sortValue.customer_id,
      from_postal_code: sortValue.sender[0].pincode,
      from_country_code: sortValue.sender[0].country_code,
      from_city_id: sortValue.sender[0].city_id,
      to_postal_code: sortValue.receiver[0].pincode,
      to_country_code: sortValue.receiver[0].country_code,
      weight: sortValue.total_weight,
      length: sortValue.length,
      height: sortValue.height,
      width: sortValue.width,
      sort_by: sort,
      parcel_type: sortValue.type,
      mode: sortValue.mode,
      payment_mode: sortValue.payment_mode,
      order_amount: sortValue.cod_amount,
      carrier_type: 1,
    };

    console.log("datatoSend", dataToSend);
    let url = config.apiUrl + "/shipment/shipment_rate_time";

    // console.log("headers => ", config.headers);

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((responseJson) => {
        console.log("responseJson => ", responseJson.data);

        setpackageloading({ ...packageloading, loading: false });
        if (responseJson.data.status == "success") {
          let sortedPackages = responseJson.data.output;

          // Sort the packages based on total charges
          if (sorting === "Cheapest") {
            sortedPackages.sort((a, b) => a.total_charges - b.total_charges);
          } else if (sorting === "Highest") {
            sortedPackages.sort((a, b) => b.total_charges - a.total_charges);
          }
          console.log("sortedPackages = ", sortedPackages);
          setpackageState(sortedPackages);

          if (responseJson.data.output.length == 0) {
            seterrorstate({
              ...errorstate,
              message:
                "No services available for the selected route and package combination.",
            });
          }
        } else {
          //  seterrorstate({...errorstate,message:"No services available for the selected route and package combination."})
          //  console.log("message",responseJson.data.message);
          Swal.fire({
            icon: "error",
            // title: 'Oops...',
            text: "Something Went wrong",
          });
        }
      })
      .catch((error) => {
        //Hide Loader
        setpackageloading({ ...packageloading, loading: false });
        // console.log(error);
      });
  };
  const openOffcanvasHandler = (sub) => {
    console.log("sub === ", sub);
    setbookorder(sub);
    setSub(sub);
    setallocatedata(sub);

    if (userstate.allocate == 0) {
      setOpenOffcanvas(true);
      get_list(sub);
    }
    //  else{
    //   console.log("allocate ==" , userstate.allocate)
    //   setbookorder(sub)
    //   console.log("book --- ---" , bookorder)
    //   setSub(sub)
    //   setTimeout(()=>{
    //     submit_detail(1)
    //   },3000)

    //   }
  };

  React.useEffect(() => {
    if (userstate.allocate != 0) {
      submit_detail(1);
    }
  }, [alloctedata]);

  const openOffdetailcanvasHandler = (sub) => {
    setOpenOffdetailcanvas(true);
    setbookorder(sub);
  };
  const closeOffdetailcanvasHandler = () => {
    setOpenOffdetailcanvas(false);
    setbookorder([]);
    // Call your get_list function here if needed
    // get_list(sub);
  };
  const closeOffcanvasHandler = () => {
    setOpenOffcanvas(false);
    setpackageState([]);
    setWarehouseState({ warehouse: "" });
    setbookorder([]);
    setallocatedata([]);
    setSub(null);
    seterrorstate({ ...errorstate, message: "" });
    // Call your get_list function here if needed
    // get_list(sub);
  };

  const submit_detail = async (type, item) => {
    // console.log("type",type)
    // console.log("courier_id",item)
    // console.log("bookorder ===== ", bookorder)
    let bookorder = alloctedata;
    const cleanedSenderMobile = bookorder.sender[0].mobile.replace(/\D/g, "");
    let formattedSenderMobile;
    if (
      cleanedSenderMobile.length > 10 &&
      cleanedSenderMobile.startsWith("91")
    ) {
      formattedSenderMobile = cleanedSenderMobile.substring(2);
    } else {
      formattedSenderMobile = cleanedSenderMobile;
    }
    const cleanedReceiverMobile = bookorder.receiver[0].mobile.replace(
      /\D/g,
      ""
    );
    // const formattedReceiverMobile = cleanedReceiverMobile.startsWith('91')
    //   ? cleanedReceiverMobile.substring(2)
    //   : cleanedReceiverMobile;
    let formattedReceiverMobile;

    if (
      cleanedReceiverMobile.length > 10 &&
      cleanedReceiverMobile.startsWith("91")
    ) {
      formattedReceiverMobile = cleanedReceiverMobile.substring(2);
    } else {
      formattedReceiverMobile = cleanedReceiverMobile;
    }

    // Remove the '+' and '91' prefixes from the mobile number
    const cleanedReturnMobile = bookorder.return[0].mobile.replace(/\D/g, "");
    let formattedReturnMobile;
    if (
      cleanedReturnMobile.length > 10 &&
      cleanedReturnMobile.startsWith("91")
    ) {
      formattedReturnMobile = cleanedReturnMobile.substring(2);
    } else {
      formattedReturnMobile = cleanedReturnMobile;
    }

    let dataToSend = {
      sender_name: bookorder.sender[0].name,
      sender_mobile: formattedSenderMobile,
      sender_email: bookorder.sender[0].email,
      sender_address: bookorder.sender[0].address,
      sender_city: bookorder.sender[0].city,
      sender_city_id: bookorder.sender[0].city_id,
      sender_country_name: bookorder.sender[0].country,
      sender_country_code: bookorder.sender[0].country_code,
      sender_postal_code: bookorder.sender[0].pincode,
      company_name: item ? item.service_name : "",
      receiver_name: bookorder.receiver[0].name,
      receiver_mobile: formattedReceiverMobile,
      receiver_email: bookorder.receiver[0].email,
      receiver_address: bookorder.receiver[0].address,
      receiver_city: bookorder.receiver[0].city,
      receiver_country_name: bookorder.receiver[0].country,
      receiver_country_code: bookorder.receiver[0].country_code,
      receiver_postal_code: bookorder.receiver[0].pincode,
      receiver_state_id: bookorder.receiver[0].state_id,
      receiver_city_id: bookorder.receiver[0].city_id,

      sender_state_name: bookorder.sender[0].state,
      receiver_state_name: bookorder.receiver[0].state,
      return_name: bookorder.return[0].name,
      return_mobile: formattedReturnMobile,
      return_email: bookorder.return[0].email,
      return_address: bookorder.return[0].address,
      return_city: bookorder.return[0].city,
      return_state_name: bookorder.return[0].state,
      return_country_name: bookorder.return[0].country,
      return_country_code: bookorder.return[0].country_code,
      return_postal_code: bookorder.return[0].pincode,
      courier_id: item && item.courier_id ? item.courier_id : "",
      product_id:
        item && item.service_provider_id ? item.service_provider_id : "",
      discount: item && item.discount ? item.discount : 0,
      payment_mode: bookorder.payment_mode,
      shipment_type: bookorder.type,
      cod_amount: bookorder.cod_amount,
      weight: bookorder.total_weight,
      length: bookorder.length,
      height: bookorder.height,
      width: bookorder.width,
      item_name: "",
      item_value: "",
      product_type_name:
        item && item.product_type_name ? item.product_type_name : "",
      total_amount: item
        ? Number(item.total_charges) + Number(item.commission_charge)
        : 0,
      tax_amount: 0,
      rate_price: item ? item.total_charges : 0,
      service_name: item && item.service_provider ? item.service_provider : "",
      carrier_id: item && item.carrier_id,
      insurance_amount: bookorder.insurance_amount
        ? bookorder.insurance_amount
        : 0,
      type: bookorder.type,
      carrier_id: item && item.carrier_id,
      address_id: bookorder.address_id,
      order_id: bookorder.order_number,
      order_date: bookorder.order_date,
      mode: bookorder.mode,
      store_id: bookorder.store_id ? bookorder.store_id : "",
      channel_name: bookorder.channel_name ? bookorder.channel_name : "",
      created_by: "Customer",
      volumetric_weight: bookorder.volumetric_weight,
      channel_id: bookorder.channel_id ? bookorder.channel_id : "",
      total_weight: bookorder.total_weight,
      payment_status: 1,
      payment_type: type != undefined ? type : 0,
      carrier_type: 1,
      order_type: bookorder.order_type
        ? bookorder.order_type == "Fulfilled"
          ? 2
          : 1
        : 1,
      zone_name: item && item.zone_name ? item.zone_name : "",
      shopify_order_number: bookorder.shopify_order_number
        ? bookorder.shopify_order_number
        : "",
      items: bookorder.items,
    };

    dataToSend.item_name = bookorder.items.map((sub) => sub.item_name);
    dataToSend.item_value = bookorder.items.map((sub) => sub.item_value);
    dataToSend.quantity = bookorder.items.map((sub) => sub.item_quantity);

    dataToSend.cust_id = bookorder.customer_id;
    console.log("datatoSend", dataToSend);

    let url = config.apiUrl + "/shipment/new_shipment_create";

    setOtherStates({ ...otherState, submit_button: false });
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((responseJson) => {
        // console.log("responseJson => ", responseJson.data.output);
        setOtherStates({ ...otherState, submit_button: true });
        if (responseJson.data.status == "success") {
          setTimeout(() => {
            setOtherStates({ ...otherState, submit_button: false });
            navigate(`/customer/shipments?type=1`, {
              replace: true,
              state: [],
            });
          }, 2000);
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Shipment booking process starts.",
            color: "white",
          });
        } else {
          setOtherStates({ ...otherState, submit_button: false });
          Swal.fire({
            icon: "error",

            text: responseJson.data.message,
          });
        }
      })
      .catch((error) => {
        setOtherStates({ ...otherState, submit_button: false });
        // console.error(error);
      });
  };

  const dateselect = (e) => {
    setdate({ ...date, [e.target.name]: e.target.value });
  };

  const modeChange = (e, value) => {
    if (e.target.checked) {
      setpaymentmode({ ...paymentmode, [e.target.name]: true });
    } else {
      setpaymentmode({ ...paymentmode, [e.target.name]: false });
    }
  };

  const handleWarehouseChange = (e, warehouseId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedWarehouses([...selectedWarehouses, warehouseId]);
    } else {
      setSelectedWarehouses(
        selectedWarehouses.filter((id) => id !== warehouseId)
      );
    }
  };
  const handleSortChange = (value) => {
    setpackageState([]);
    setSortOption(value);
    if (sub) {
      get_list(sub, value); // Use the updated 'sub' value along with sorting option
    }
  };
  return (
    <div>
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="home-section">
        <Header />

        <Modal
          show={modalState.show}
          onHide={() => setModalState({ show: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 class="modal-title">Bulk Shipment</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="modal-body">
              <div class="card border-0 shadow-sm bg-warning mb-3">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div class="p-3">
                      <i class="material-icons-outlined">emoji_objects</i>
                    </div>
                    <div class="ps-2 ">
                      <p>
                        Please select the appropiate product type along with
                        Carrier to process the bulk shipment operation. Please
                        check the log for any error.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <label for="" class="form-label">
                Select Product Type:
              </label>
              <select class="form-select" onChange={(e) => onChangeProduct(e)}>
                <option>Select Product Type:</option>
                {product.map((sub) => (
                  <option value={[sub.product_id, sub.carrier_id]}>
                    {sub.product_name}{" "}
                  </option>
                ))}
              </select>
              {onSubmitButton == false ? (
                <div class="d-grid mt-3">
                  <a
                    class="btn btn-primary btn-block"
                    onClick={() => onsubmit()}
                  >
                    Submit
                  </a>
                </div>
              ) : (
                ""
              )}

              <hr />
              <div class="d-flex justify-content-between mt-3">
                <div class=""></div>
                <div class="">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    data-bs-dismiss="modal"
                    onClick={() => modalClose()}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <div class="row mb-2">
          <div class="col-6 col-md">
            <div class="d-flex">
              <div class="back_btn_wrap">
                <a href="" class="back_btn">
                  {/* <i data-lucide="corner-up-left"></i> */}
                  <CornerUpLeft />
                </a>
              </div>

              <div class="">
                <h2>Orders</h2>
              </div>
              {/* <!-- <div class="ps-2 ">
                            <select class="form-select form-select-sm">
                                <option>All</option>
                                <option>Domestic</option>
                                <option>International</option>
                            </select>   
                        </div> --> */}
            </div>
          </div>

          <div class="col-6 col-md-7 text-end btns">
            <div className="hide_order_button">
              {/* {syncLoading?
             <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={20} />:
            <a onClick={()=>syncOrders()} class="btn btn-secondary-o btn-sm"> <RefreshCcw /> Sync Orders</a>
} */}
              {/* <a href="#" class="btn btn-secondary-o btn-sm"><i data-lucide="refresh-ccw"></i> Sync Orders</a> */}
              <a
                onClick={() =>
                  navigate({
                    pathname: "/customer/order_import",
                  })
                }
                class="btn btn-secondary-o btn-sm ms-2"
              >
                <Upload /> Bulk Orders
              </a>
              <a
                onClick={() =>
                  navigate({
                    pathname: "/customer/create_order_1",
                    search: `value=0`,
                  })
                }
                class="btn btn-primary btn-sm ms-2"
              >
                <Plus /> Create New Order
              </a>
              <a
                href="/customer/bulk_orders_logs"
                class=" btn btn-secondary-o btn-sm m-2"
                style={{ textDecoration: "none" }}
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i> Bulk Order
                Log
              </a>
            </div>

            <div className="action_orders">
              <div class="dropdown">
                <button
                  type="button"
                  class="btn btn-primary dropdown-toggle btn-sm"
                  data-bs-toggle="dropdown"
                >
                  Action
                </button>
                <ul class="dropdown-menu">
                  <li>
                    {/* {syncLoading?
             <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={20} />:
            <a onClick={()=>syncOrders()} class="dropdown-item"> <RefreshCcw /> Sync Orders</a>
} */}
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        navigate({
                          pathname: "/customer/order_import",
                        })
                      }
                      class="dropdown-item"
                    >
                      <Upload /> Bulk Orders
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a
                      onClick={() =>
                        navigate({
                          pathname: "/customer/create_order_1",
                          search: `value=0`,
                        })
                      }
                      class="dropdown-item"
                    >
                      <Plus /> Create New Order
                    </a>
                  </li>
                  <li>
                    <a
                      href="/customer/bulk_orders_logs"
                      class="dropdown-item"
                      style={{ textDecoration: "none" }}
                    >
                      <i class="fa fa-info-circle" aria-hidden="true"></i> Bulk
                      Order Log
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md">
            <div class="row g-1">
              <div class="col-12 col-md-3">
                <div class="input-group input-group-sm mb-3">
                  {/* <select class="form-select">
                                    <option>Order ID</option>
                                    <option>Phone Number</option>
                                </select> */}
                  <input
                    type="text"
                    class="form-control"
                    name="search_shipment"
                    placeholder="Enter Order Number"
                    onChange={(e) => handlesearchShipment(e)}
                  />
                  <button
                    class="btn btn-outline-primary"
                    onClick={(e) => shipment_list(null, 0, true)}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div class="col-5 col-md-2">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  id="text"
                  placeholder="Enter details name="
                  name="from_date"
                  value={date.from_date}
                  onChange={(e) => dateselect(e)}
                />
              </div>
              <div class="col-5 col-md-2">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  id="text"
                  placeholder="Enter details name="
                  name="to_date"
                  value={date.to_date}
                  onChange={(e) => dateselect(e)}
                />
              </div>
              <div class="col-2 col-md-1 ">
                <div className="input-group input-group-sm">
                  <button
                    class="btn btn-outline-primary "
                    onClick={(e) => shipment_list(null, 0, true)}
                  >
                    Search
                  </button>
                </div>
              </div>

              <div class="col-6 col-md-2 filter_order">
                <div class="dropdown">
                  <button
                    type="button"
                    class="btn btn-theme btn-sm dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Pickup Location
                  </button>
                  <ul class="dropdown-menu">
                    {warehouse.map((sub) => (
                      <li key={sub.address_id}>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id={`warehouseCheckbox${sub.address_id}`}
                            value={sub.address_id}
                            onChange={(e) =>
                              handleWarehouseChange(e, sub.address_id)
                            }
                            checked={selectedWarehouses.includes(
                              sub.address_id
                            )}
                          />
                          <label
                            class="form-check-label"
                            for={`warehouseCheckbox${sub.warehouse_id}`}
                          >
                            {sub.warehouse_id}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div class="col-6 col-md-2 filter_order">
                <div class="dropdown">
                  <button
                    type="button"
                    class="btn btn-theme btn-sm dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Payment Mode
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="inlineCheckbox1"
                          value="option1"
                          name="cod"
                          onChange={(e) => modeChange(e)}
                          checked={paymentmode.cod}
                        />
                        <label class="form-check-label" for="inlineCheckbox1">
                          Cash On Delivery
                        </label>
                      </div>
                    </li>
                    <li>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="inlineCheckbox1"
                          value="option1"
                          name="prepaid"
                          onChange={(e) => modeChange(e)}
                          checked={paymentmode.prepaid}
                        />
                        <label class="form-check-label" for="inlineCheckbox1">
                          Prepaid
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          {selected.select_count == 0 ? (
            ""
          ) : (
            <div class="col-12 col-md btns">
              <a href="#" class="btn btn-text btn-sm fw-300">
                <strong>{selected.select_count} selected</strong>
              </a>
              {userstate.aadhar_kyc != undefined &&
              userstate.aadhar_kyc == true ? (
                <a
                  class="btn btn-primary btn-sm"
                  onClick={() => showModal()}
                  data-bs-toggle="modal"
                  data-bs-target="#bulkship"
                >
                  <Truck /> Ship Now
                </a>
              ) : (
                <a
                  class="btn btn-outline-secondary btn-sm"
                  href="/customer/customer_kyc"
                >
                  <strong></strong> Need Kyc First
                </a>
              )}
              {/* <a href="#" class="btn btn-primary btn-sm"><i data-lucide="truck"></i> Ship Now</a> */}
              <a
                onClick={() => cancelBulkOrder()}
                class="btn btn-outline-danger btn-sm ms-1"
              >
                <Trash /> Delete Orders
              </a>
            </div>
          )}
        </div>

        <div class="content-wrapper-data">
          <div class="card border-0">
            <div class="card-body">
              <div class="table-data table-responsive">
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginLeft: "80px",
                      alignItems: "center",
                      marginTop: "-200px",
                      height: "100vh",
                    }}
                  >
                    <ReactLoading
                      type={"spin"}
                      color={"#0d6efd"}
                      height={40}
                      width={60}
                    />
                  </div>
                ) : (
                  <table class="table table-hover table-responsive">
                    <thead>
                      <tr class="table-light">
                        <th>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th>Order #</th>
                        <th>Customer Details</th>
                        <th>Value</th>
                        <th>Package Details</th>
                        {/* <th>Channel</th> */}
                        <th>Pickup Address</th>
                        <th>Product Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state.shipment_list.map((sub) => (
                        <tr class="ship-now-container">
                          <td>
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="inlineCheckbox1"
                              checked={selected.select_order_id.includes(
                                sub.order_number
                              )}
                              value="option1"
                              onChange={(e) => handleChangeSelected(e, sub)}
                            />
                          </td>
                          <td>
                            <h3>
                              <a
                                onClick={() => openOffdetailcanvasHandler(sub)}
                                style={{ cursor: "pointer" }}
                              >
                                {sub.order_number}
                              </a>
                            </h3>
                            <h6></h6>
                            <Moment format="MMM DD YYYY">
                              {sub.order_date}
                            </Moment>{" "}
                            -{" "}
                            <Moment format="hh:mm:ss a">
                              {new Date(sub.order_created * 1000)}
                            </Moment>
                          </td>
                          {sub.receiver.map((item) => (
                            //                         <td>
                            //                             <h4>{item.address}</h4>
                            //                             <small>{item.city}</small>
                            //                             <h6>{item.state}</h6>
                            //                             <small>{item.pincode}</small>

                            //                         </td>
                            //
                            <td>
                              <h4>{item.address}</h4>
                              <h6>
                                {item.city} , {item.state} - {item.pincode}
                              </h6>
                              <h6>{item.mobile}</h6>
                            </td>
                          ))}
                          <td>
                            {/* <h4>₹ 2000.00</h4> */}
                            <small>
                              <span class="badge rounded-pill bg-warning fw-400">
                                {sub.payment_mode}
                              </span>
                            </small>
                          </td>
                          <td>
                            <h4>
                              Dead wt. :{" "}
                              {sub.dead_weight != undefined
                                ? sub.dead_weight
                                : ""}{" "}
                              kg
                            </h4>
                            <small>
                              {sub.height != undefined ? sub.height : ""} x{" "}
                              {sub.width != undefined ? sub.width : ""} x{" "}
                              {sub.length != undefined ? sub.length : ""} (cm)
                            </small>
                            <h6>
                              Volumetric wt.:{" "}
                              {sub.volumetric_weight != undefined
                                ? sub.volumetric_weight
                                : ""}{" "}
                              Kg
                            </h6>
                            {/* <h4>Dead wt. : 1.00 kg</h4>
                                        <small>1.00 x 1.00 x 1.00 (cm)</small>
                                        <h6>Volumetric wt.:  0 Kg</h6> */}
                          </td>
                          {/* <td class="channel_logo">
                                        <a href=""data-bs-toggle="tooltip" data-bs-placement="top" title="Direct Sales"><img src="images/dire_sales.png" class="img-fluid" /></a>
                                    </td> */}
                          <td>
                            <h6>
                              <a
                                href="#"
                                class=""
                                data-bs-toggle="popover"
                                data-bs-placement="top"
                                data-bs-trigger="hover"
                                data-bs-content="St.293, NY, USA - 300393"
                              >
                                {sub.warehouse_id
                                  ? sub.warehouse_id
                                  : sub.warehouse_name}
                              </a>
                            </h6>
                          </td>
                          <td>
                            {sub.items[0].item_name.substring(0, 20) + "..."}{" "}
                            {sub.items.length > 1 ? "+1 items" : ""}
                            <div class="custom-buttons button-container">
                              <div class="d-flex justify-content-between">
                                <div class="">
                                  <button
                                    type="button"
                                    class="btn btn-primary ship_now"
                                    onClick={() => openOffcanvasHandler(sub)}
                                  >
                                    Ship Now
                                  </button>
                                </div>
                                <div class="p-2 ship_now_2">
                                  <div class="mb-1">
                                    <a
                                      onClick={() => edit_order(sub)}
                                      class="btn btn-secondary btn-sm"
                                      data-bs-toggle="tooltip"
                                      title="Edit Order"
                                    >
                                      <i
                                        class="fa fa-pencil"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                  <div class="mb-1">
                                    <a
                                      onClick={(e) => clone_order(sub)}
                                      class="btn btn-secondary btn-sm"
                                      data-bs-toggle="tooltip"
                                      title="Clone Order"
                                    >
                                      <i
                                        class="fa fa-clone"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                  <div>
                                    <a
                                      onClick={(e) => cancelOrder(sub)}
                                      class="btn btn-secondary btn-sm"
                                      data-bs-toggle="tooltip"
                                      title="Cancel Order"
                                    >
                                      <i
                                        class="fa fa-ban"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {/* <tr class="ship-now-container">
                                    <td>
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                                    </td>
                                    <td>
                                        <div class="d-flex">
                                            <div class="">
                                                <a href="" class="text-danger"  data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Missing fields: warehouse, dimenshions, weight, receiver email, receiver mobile, other"><i data-lucide="alert-triangle"></i></a>
                                            </div>
                                            <div class="ps-2 ">
                                                <h3><a href="#"  data-bs-toggle="offcanvas" data-bs-target="#order_details">#1233494</a></h3>
                                            <h6>Dec 9, 2:28PM</h6>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <h4>Simran Malkani</h4>
                                        <h6>Maharashtra - 400071</h6>
                                        <h6>9900992383</h6>
                                    </td>
                                    <td>
                                    <h4>₹ 2000.00</h4>
                                        <small><span class="badge rounded-pill bg-warning fw-400">Prepaid</span></small>
                                    </td>
                                    <td>
                                        <h4>Dead wt. : 1.00 kg</h4>
                                        <small>1.00 x 1.00 x 1.00 (cm)</small>
                                        <h6>Volumetric wt.:  0 Kg</h6>
                                    </td>
                                    <td class="channel_logo">
                                        <a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Indochina Store"><img src="images/shopify.png" class="img-fluid" /></a>
                                    </td>
                                    <td>
                                        <h6><a href="#" class="" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="St.293, NY, USA - 300393">Mumbai Bk</a></h6>
                                    </td>
                                    <td>
                                        
                                        iphone 12 pro max +1 items  
                                        <div class="custom-buttons">
                                            <div class="d-flex justify-content-between">
                                                <div class="">
                                                    <button type="button" class="btn btn-primary ship_now"  data-bs-toggle="offcanvas" data-bs-target="#product_lists">Ship Now</button>
                                                </div>
                                                <div class="p-2 ship_now_2">
                                                    <div class="mb-1">
                                                        <a href="#" class="btn btn-secondary btn-sm"data-bs-toggle="tooltip" title="Edit Order">
                                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                                        </a>
                                                    </div>
                                                    <div class="mb-1">
                                                        <a href="#" class="btn btn-secondary btn-sm"data-bs-toggle="tooltip" title="Clone Order">
                                                            <i class="fa fa-clone" aria-hidden="true"></i>
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <a href="#" class="btn btn-secondary btn-sm" data-bs-toggle="tooltip" title="Cancel Order">
                                                            <i class="fa fa-ban" aria-hidden="true"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr> */}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <div class="offcanvas offcanvas-end products_lists" id="product_lists">
                <div class="offcanvas-header">
                  <div class="offcanvas-title">
                    <small>From Warehouse</small>
                    <select class="form-select" disabled>
                        <option>Mumbai Warehouse (302017)</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                      </select>
                    </div>
                  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
                </div>
                <hr/>
                <div class="offcanvas-body ">
                    <div class="card ">
                      <div class="card-body">
                        <div class="row g-1">
                            <div class="col-12 col-md">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Delhivery_Logo_%282019%29.png/800px-Delhivery_Logo_%282019%29.png?20190506185741" class="img-fluid" />
                                <h3>Delhivery Overnight B2C </h3>
                                <small>Surface | Min-weight: 0.5 kg</small>
                            </div>
                            <div class="col-12 col-md-4">
                                <h2>₹119.68</h2>
                                <button class="btn btn-primary btn-sm book-now-button">Book Now</button>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div> */}
        {openOffcanvas && (
          <div
            className="offcanvas offcanvas-end products_lists show"
            id="product_lists"
          >
            {/* Your offcanvas content goes here */}
            <div class="offcanvas-header">
              <div class="offcanvas-title">
                <small>From Warehouse</small>
                <select class="form-select" disabled>
                  <option>{warehosuestate.warehouse}</option>
                </select>
              </div>
              <button
                type="button"
                class="btn-close text-reset"
                onClick={() => closeOffcanvasHandler()}
              ></button>
            </div>
            <hr />
            <div className="offcanvas-header">
              <div class="col-12 col-md-12">
                <select
                  class="form-select form-select-sm"
                  onChange={(e) => handleSortChange(e.target.value)}
                >
                  <option value="Recommended">Sort By: Recommended</option>
                  <option value="Cheapest">Sort By: Low to High</option>
                  <option value="Highest">Sort By: High to Low</option>
                </select>
              </div>
            </div>
            {packageloading.loading ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ReactLoading type={"spin"} color={"#0d6efd"} />
              </div>
            ) : (
              ""
            )}
            <h3>{errorstate.message}</h3>
            {packagestate.length > 0 ? (
              <div class="offcanvas-body ">
                {packagestate.map((item) => (
                  <div class="card ">
                    <div class="card-body">
                      <div class="row g-1">
                        <div class="col-12 col-md">
                          {dimensionState.companyDetail[0].hide_carrier ? (
                            ""
                          ) : (
                            <img
                              src={`https://cdn.shiprath.com/images/${item.carrierImage}`}
                              class="img-fluid"
                            />
                          )}
                          <h3>{item.service_provider} </h3>
                          <small>
                            {item.product_type_name
                              ? item.product_type_name
                              : ""}
                          </small>
                        </div>
                        <div class="col-12 col-md-4">
                          <h3>
                            {/* {dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_currency}</>
                                 ))} */}
                            ₹
                            {parseFloat(
                              Number(item.total_charges) +
                                Number(item.commission_charge)
                            ).toFixed(2)}
                          </h3>
                          <button
                            class="btn btn-primary btn-sm book-now-button"
                            onClick={() => submit_detail(1, item)}
                          >
                            Book Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        )}

        {openOffdetailcanvas && (
          <section className="order_info_offcanvas show">
            <div
              class="offcanvas offcanvas-end order_details show"
              id="order_details"
            >
              <div class="offcanvas-header">
                <div class="offcanvas-title">
                  <div class="row mb-2">
                    <div class="col-8 col-md-6">
                      <h2>
                        <small>Order # {bookorder.order_number}</small>
                      </h2>
                    </div>

                    <div class="col-4 col-md-6 text-end btns">
                      <a
                        onClick={() => edit_order(bookorder)}
                        class="btn btn-secondary-o btn-sm me-1"
                        data-bs-toggle="tooltip"
                        title="Edit Order"
                      >
                        <FileEdit />
                      </a>
                      <a
                        onClick={(e) => clone_order(bookorder)}
                        class="btn btn-secondary-o btn-sm me-1"
                        data-bs-toggle="tooltip"
                        title="Clone Order"
                      >
                        <Copy />
                      </a>
                      <a
                        onClick={(e) => cancelOrder(bookorder)}
                        class="btn btn-secondary-o btn-sm"
                        data-bs-toggle="tooltip"
                        title="Cancel Order"
                      >
                        <Ban />
                      </a>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn-close text-reset"
                  onClick={() => closeOffdetailcanvasHandler()}
                ></button>
              </div>
              <div class="offcanvas-body">
                <div class="">
                  <div class="row mt-3 order_box_cont">
                    <div class="col-12 col-md-12 ">
                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              {/* <i data-lucide="shopping-bag"></i> */}
                              <ShoppingBag />
                            </div>
                            <div class="ps-3 ">
                              <h6>Order Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">
                                Order created on channel
                              </small>
                              <p>{bookorder.order_date}</p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">
                                Order created on system
                              </small>
                              <p>{bookorder.order_date}</p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">Channel</small>
                              <p>
                                {bookorder.channel_name
                                  ? bookorder.channel_name
                                  : ""}
                              </p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">Shipment value</small>
                              <p>
                                ₹{" "}
                                {bookorder.items
                                  .reduce(
                                    (total, sub) =>
                                      total + parseFloat(sub.item_value),
                                    0
                                  )
                                  .toFixed(2)}{" "}
                                <span class="badge rounded-pill bg-warning">
                                  {bookorder.payment_mode}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              {/* <i data-lucide="package"></i> */}
                              <Package />
                            </div>
                            <div class="ps-3 ">
                              <h6>Shipment Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col-12 col-md">
                              <h6>Ship From:</h6>
                              <small class="text-muted">Sender Name:</small>
                              <p>{bookorder.sender[0].name}</p>
                              <small class="text-muted">Sender Address:</small>
                              <p>
                                {bookorder.sender[0].address},
                                {bookorder.sender[0].city},{" "}
                                {bookorder.sender[0].state}{" "}
                                {bookorder.sender[0].pincode}
                              </p>
                              <small class="text-muted">Sender Email:</small>
                              <p>{bookorder.sender[0].email}</p>
                              <small class="text-muted">Sender Mobile:</small>
                              <p>{bookorder.sender[0].mobile}</p>
                            </div>
                            <div class="col-12 col-md">
                              <h6>Ship To:</h6>
                              <small class="text-muted">Receiver Name:</small>
                              <p>{bookorder.receiver[0].name}</p>
                              <small class="text-muted">
                                Receiver Address:
                              </small>
                              <p>
                                {bookorder.receiver[0].address},
                                {bookorder.receiver[0].city},{" "}
                                {bookorder.receiver[0].state}{" "}
                                {bookorder.receiver[0].pincode}
                              </p>
                              <small class="text-muted">Receiver Email:</small>
                              <p>{bookorder.receiver[0].email}</p>
                              <small class="text-muted">Receiver Mobile:</small>
                              <p>{bookorder.receiver[0].mobile}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0  mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              {/* <i data-lucide="package-open"></i> */}
                              <PackageOpen />
                            </div>
                            <div class="ps-3 ">
                              <h6>Package Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Applicable Weight (in Kg)
                              </small>
                              <p>{bookorder.total_weight}KG</p>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Dead Weight (in Kg)
                              </small>
                              <p>{bookorder.dead_weight}KG</p>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Volumetric Weight (in kg)
                              </small>
                              <p>{bookorder.volumetric_weight}KG</p>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Dimensions (in cm)
                              </small>
                              <p>
                                {bookorder.height} x {bookorder.width} x{" "}
                                {bookorder.length}
                              </p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">Number of Boxes</small>
                              <p>1</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              {/* <i data-lucide="shopping-basket"></i> */}
                              <ShoppingBasket />
                            </div>
                            <div class="ps-3 ">
                              <h6>Product Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="table-responsive ">
                            <table class="table table-light">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  {/* <th>Category</th> */}
                                  {/* <th>HSN</th> */}
                                  {/* <th>SKU</th> */}
                                  <th>Qty</th>
                                  <th>Unit price</th>
                                  {/* <th>Discount</th> */}
                                  {/* <th>Tax</th> */}
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {bookorder.items.map((sub) => (
                                  <tr>
                                    <td>{sub.item_name}</td>
                                    {/* <td>1689070274414</td> */}
                                    {/* <td>samsung-A50</td> */}
                                    {/* <td>1</td> */}
                                    <td>{sub.item_quantity}</td>
                                    <td>{sub.item_value}</td>
                                    {/* <td>100.00</td> */}
                                    {/* <td>10.00</td> */}
                                    <td>
                                      {" "}
                                      {bookorder.items
                                        .reduce(
                                          (total, sub) =>
                                            total +
                                            parseFloat(
                                              sub.item_value * sub.item_quantity
                                            ),
                                          0
                                        )
                                        .toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        <TablePagination
          component="div"
          rowsPerPageOptions={[500, 800, 1000]}
          count={otherStates.total_count}
          page={otherStates.page}
          onPageChange={handlePageChange}
          rowsPerPage={otherStates.rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      <Footer value={2} />
    </div>
  );
};

export default Customer_orders;
